import { classNames } from 'primereact/utils'

import { EinvoiceValidationresult } from '../../../../data/models'

type Props = {
  status?: EinvoiceValidationresult['Level']
  size?: 'small' | 'large'
}

export const RoundedStatusIcon: React.FC<Props> = ({ status, size }) => {
  if (!status) return null

  let icon = ''
  let severity = ''

  switch (status) {
    case 'Error':
      icon = 'pi-times'
      severity = 'bg-red-500'
      break
    case 'DisabledError':
      icon = 'pi-exclamation-circle'
      severity = 'bg-cyan-500'
      break
    case 'Warn':
      icon = 'pi-exclamation-triangle'
      severity = 'bg-yellow-500'
      break
    case 'Success':
      icon = 'pi-check'
      severity = 'bg-green-500'
      break
    default:
      icon = ''
      severity = 'bg-gray-500'
  }

  let iconSize = '24px'
  let textSize = 'text-sm'

  switch (size) {
    case 'small':
      iconSize = '16px'
      textSize = 'text-xs'
      break
    case 'large':
      iconSize = '32px'
      textSize = 'text-lg'
      break
    default:
      iconSize = '24px'
      textSize = 'text-sm'
  }

  return (
    <span
      style={{ height: iconSize, width: iconSize }}
      className={classNames(
        'inline-flex flex-shrink-0 align-items-center justify-content-center align-items-center border-circle z-1 text-white',
        severity,
      )}
    >
      <i className={`pi ${icon} ${textSize}`} />
    </span>
  )
}
